import React from 'react';
import styles from './UnstyledTextInput.module.css.js';
import { clsx } from 'clsx';
import { BoxWithFallback } from './BoxWithFallback.js';
import { jsx } from 'react/jsx-runtime';

const UnstyledTextInput = /*#__PURE__*/React.forwardRef(function UnstyledTextInput({
  className,
  ...rest
}, forwardRef) {
  return /*#__PURE__*/jsx(BoxWithFallback, {
    as: "input",
    ref: forwardRef,
    ...rest,
    className: clsx(className, styles.Input)
  });
});
UnstyledTextInput.displayName = 'UnstyledTextInput';

export { UnstyledTextInput as default };
